import { useTranslation } from "react-i18next";
import type { FC } from "react";

import {
    LOCALE_LABELS,
    SUPPORTED_LOCALES,
    type AppLocale,
} from "i18n/locale";
import { useLocalePreferences } from "providers/LocalePreferencesProvider";
import { useToast } from "providers/ToastProvider";

const LanguageSettingsPanel: FC = () => {
    const { t } = useTranslation("settings");
    const { locale, setLocale } = useLocalePreferences();
    const { addToast } = useToast();

    const handleSelect = (next: AppLocale) => {
        if (next === locale) return;
        setLocale(next);
        addToast({ type: "success", message: t("language.saved") });
    };

    return (
        <div className="flex max-w-3xl flex-col gap-6">
            <div>
                <p className="text-h4 font-semibold text-white">
                    {t("language.title")}
                </p>
                <p className="mt-1 text-h5 text-black40">
                    {t("language.description")}
                </p>
            </div>

            <div className="rounded-r10 border border-black80 bg-black90 p-4">
                <p className="text-h5 font-semibold text-white">
                    {t("language.current")}
                </p>
                <div className="mt-4 flex flex-col gap-2">
                    {SUPPORTED_LOCALES.map((code) => {
                        const selected = locale === code;
                        return (
                            <button
                                key={code}
                                type="button"
                                onClick={() => handleSelect(code)}
                                className={`flex w-full items-center justify-between rounded-r5 border px-4 py-3 text-left text-h5 transition-colors ${
                                    selected
                                        ? "border-primary2 bg-black80 text-white"
                                        : "border-black80 bg-black70 text-black40 hover:border-black60 hover:bg-black60 hover:text-white"
                                }`}
                                aria-pressed={selected}
                            >
                                <span>{LOCALE_LABELS[code]}</span>
                                {selected ? (
                                    <span className="text-primary2" aria-hidden>
                                        ●
                                    </span>
                                ) : null}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default LanguageSettingsPanel;
